xplenty.service(
  'ComponentEditorListeners',
  class ComponentEditorListeners {
    constructor() {
      this.onSaveListeners = [];
      this.onSaveSuccessListeners = [];
      this.onCancelListeners = [];
    }

    onSave(fn) {
      if (angular.isFunction(fn)) {
        this.onSaveListeners.push(fn);
      }
    }

    onSaveSuccess(fn) {
      if (angular.isFunction(fn)) {
        this.onSaveSuccessListeners.push(fn);
      }
    }

    onCancel(fn) {
      if (angular.isFunction(fn)) {
        this.onCancelListeners.push(fn);
      }
    }

    clearOnSaveCb(fn) {
      const fnIndex = this.onSaveListeners.indexOf(fn);
      if (fnIndex > -1) this.onSaveListeners.splice(fnIndex, 1);
    }

    clearOnSaveSuccessCb(fn) {
      const fnIndex = this.onSaveSuccessListeners.indexOf(fn);
      if (fnIndex > -1) this.onSaveSuccessListeners.splice(fnIndex, 1);
    }

    clearOnCancelCb(fn) {
      const fnIndex = this.onCancelListeners.indexOf(fn);
      if (fnIndex > -1) this.onCancelListeners.splice(fnIndex, 1);
    }
  },
);
